module.exports = __webpack_public_path__ + "static/logo-transparent-547411373bd4b0238f9340577ce6932e.png";